import { createContext, useContext } from 'react';

export const EnabledFeaturesContext = createContext<
  Record<string, boolean | undefined> | undefined
>(undefined);

export const { Provider: EnabledFeaturesContextProvider } =
  EnabledFeaturesContext;

export const useEnabledFeaturesContext = () => {
  const context = useContext(EnabledFeaturesContext);
  if (!context) {
    throw new Error(
      'useEnabledFeaturesContext must be used within an EnabledFeaturesContextProvider'
    );
  }
  return context;
};
